import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";

export default function Collections() {
  const { slug } = useParams();
  const [collections, setCollections] = useState([]);
  const [products, setProducts] = useState([]);
  const [current, setCurrent] = useState(null);

  useEffect(() => {
    api.get("/collections").then(r => {
      setCollections(r.data);
      if (slug) setCurrent(r.data.find(c => c.slug === slug));
    });
    if (slug) api.get("/products", { params: { collection: slug, limit: 60 } }).then(r => setProducts(r.data));
  }, [slug]);

  if (slug && current) {
    return (
      <div data-testid={`collection-page-${slug}`}>
        <section className="relative min-h-[50vh] flex items-center overflow-hidden">
          <img src={current.image} alt="" className="absolute inset-0 w-full h-full object-cover opacity-55"/>
          <div className="absolute inset-0 bg-gradient-to-b from-[#12100E]/60 to-[#12100E]"/>
          <div className="relative max-w-4xl mx-auto text-center px-6 py-24">
            <div className="eyebrow">Collection</div>
            <h1 className="font-serif-luxe text-5xl sm:text-6xl text-[#FAF8F5] mt-4">{current.name}</h1>
            <p className="text-[#C2B29F] mt-4 max-w-xl mx-auto">{current.description}</p>
          </div>
        </section>
        <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
            {products.map((p, i) => <ProductCard key={p.id} product={p} index={i}/>)}
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16" data-testid="collections-page">
      <div className="text-center mb-14">
        <div className="eyebrow">Curated Stories</div>
        <h1 className="font-serif-luxe text-5xl text-[#FAF8F5] mt-3">The Collections</h1>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
        {collections.map((c, i) => (
          <Link key={c.slug} to={`/collections/${c.slug}`} className="group relative aspect-[16/10] overflow-hidden bg-[#221712] reveal" style={{animationDelay: `${i*80}ms`}}>
            <img src={c.image} alt={c.name} className="w-full h-full object-cover opacity-75 group-hover:opacity-100 group-hover:scale-105 transition-all duration-[1200ms]"/>
            <div className="absolute inset-0 bg-gradient-to-t from-[#12100E] via-[#12100E]/40 to-transparent"/>
            <div className="absolute inset-x-0 bottom-0 p-8">
              <div className="eyebrow text-[#D4AF37]">{c.tagline}</div>
              <div className="font-serif-luxe text-3xl text-[#FAF8F5] mt-2">{c.name}</div>
              <div className="mt-3 text-sm text-[#C2B29F] max-w-md">{c.description}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
